import { Box, IconNewOptions, SpacerNew, Text } from '@jfs/ui-new'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { Colors } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { TooltipView } from '../TootTipView'
import { DefaultDropDown } from './DefaultDropDown'
import { DropDownBox } from './DropDownBox'
import { defaultButtonLabel, defaultSelectedFileType, dropdownPlacementTopValue } from './DropdownConstants'
import { renderPortal } from './DropdownPotal'
import { RadioButtonDropdown } from './RadioButtonDropdown'
import { styles } from './styles'
import { DropDownProps, DropdownTypes, itemSelected } from './types'

const zIndex = 999999 //This high value because modal too has some zindex due to which it gets hidden when opent in modal.
//const customRange = 'Custom Range'
const DropdownOptimised: React.FC<DropDownProps> = ({
  placeHolder,
  onChange,
  data,
  type = DropdownTypes.DEFAULT_WITH_IMAGE,
  doropdownContainerTitle = 'SEARCH BY',
  hide = false,
  buttonLabel = defaultButtonLabel,
  iconType = null,
  onButtonPress,
  title = '',
  dropDownContentFontSize,
  chevronColor,
  dropdownWidth,
  setFieldValue,
  label,
  fieldName,
  disabled = false,
  disabledBg = 'GRAY_HALF',
  error,
  touched,
  labelColor = 'BLACK_21',
  labelFontFamily = 'jiotype-bold',
  toolTipInfo = '',
  borderColor = 'DISABLED_GREY',
  testID,
  buttonWidth,
  titleColor = 'BLACK_21',
  fontWeight = '600',
  labelPaddingBottom = 0,
  boxheight = 35,
  dropdownHeight,
  ...props
}: DropDownProps) => {
  const [dropdownVisible, toggleDropdown] = useState(false)
  const [value, setValue] = useState(props.value ?? placeHolder)
  const [dropdownData, setDropdDownData] = useState(data)
  const [fileFormatType, updateFileFormat] = useState(defaultSelectedFileType)
  const [layoutValue, onLayout] = useState({ left: 0, top: 0 })

  const isExportType = type === DropdownTypes.RADIO_BUTTON

  const onDropdownItemPress = (item: itemSelected) => {
    const selectedValue = item?.value ?? ''
    /*   if (selectedValue === customRange) {
      updateLabel('')
    } else {
      updateLabel(item?.value)
    } */
    toggleDropdown(!dropdownVisible)
    if (type !== DropdownTypes.ADD_BENEFICIARY) {
      setValue(selectedValue)
    }
    onChange(selectedValue)
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, selectedValue)
    }
  }

  const clearSelection = () => {
    // updateLabel(title)
    toggleDropdown(false)
    onChange('')
  }

  const handleDownload = (): void => {
    toggleDropdown(!dropdownVisible)
    if (onButtonPress) {
      onButtonPress(fileFormatType)
    }
  }

  let dropdownContentHeight = dropdownHeight
    ? dropdownHeight
    : dropdownData?.length
    ? dropdownData?.length * 43 + dropdownPlacementTopValue
    : 250
  let top = layoutValue?.top + dropdownPlacementTopValue
  top =
    top + dropdownContentHeight > Dimensions.get('window').height
      ? Dimensions.get('window').height - dropdownContentHeight
      : top
  const renderDropDown = (): React.ReactElement => {
    return (
      <ModBox
        {...styles.modal}
        zIndex={zIndex}
        onPress={() => [toggleDropdown(false)]}
        show={data && dropdownVisible}
        nativeID={'dropdown-wrapper'}>
        <Box
          {...styles.dropdownContainer}
          width={dropdownWidth}
          maxHeight={dropdownHeight}
          borderWidth={1}
          left={type === DropdownTypes.DEFAULT_WITH_BG ? layoutValue?.left - 8 : layoutValue?.left}
          top={top}
          pb={type === DropdownTypes.DEFAULT_WITH_IMAGE ? 0 : 5}>
          <ModBox
            show={type === DropdownTypes.DEFAULT_WITH_BG && doropdownContainerTitle?.length}
            p={16}
            borderBottomWidth={1}
            w={210}
            borderBottomColor={'LIGHTEST_GREY_2'}>
            <Text
              fontSize={12}
              color={labelColor ?? Colors.HELPER_TEXT}
              letterSpacing={1.2}
              fontFamily={'jiotype-medium'}
              title={doropdownContainerTitle}
            />
          </ModBox>
          <DefaultDropDown
            data={dropdownData}
            isExportType={isExportType}
            onDropdownItemPress={onDropdownItemPress}
            selectedValue={type === DropdownTypes.DEFAULT_WITH_BG ? '' : placeHolder}
            fontSize={dropDownContentFontSize}
            height={dropdownHeight}
            width={dropdownWidth}
            testId={testID}
          />
          <RadioButtonDropdown
            data={dropdownData}
            isExportType={isExportType}
            fileFormatType={fileFormatType}
            updateFileFormat={updateFileFormat}
            handleDownload={handleDownload}
            buttonLabel={buttonLabel}
            downloadBtntestID={'downloadBtn'}
          />
        </Box>
      </ModBox>
    )
  }

  useEffect(() => {
    setValue(props.value ?? placeHolder)
    setDropdDownData(data)
  }, [data, placeHolder, props.value])

  const showBorder = type !== DropdownTypes.DEFAULT_WITHOUT_BORDER && type !== DropdownTypes.DEFAULT_WITH_BG

  if (hide) {
    return null
  } else {
    const isIconAvailable = iconType !== null
    return (
      <Box {...(props.containerStyle ?? '')}>
        <ModBox show={!!label} flexDirection="row" pb={labelPaddingBottom}>
          <Text
            color={labelColor ?? 'BLACK_21'}
            title={label}
            fontFamily={labelFontFamily}
            lineHeight={20}
            fontSize={12}
          />
          <SpacerNew size={8} direction="horizontal" />
          <ModBox show={toolTipInfo?.length > 0} direction="row" alignItems={'center'}>
            <TooltipView value={toolTipInfo} alignLeft={true} iconSize={12} />
          </ModBox>
        </ModBox>
        <DropDownBox
          testID={testID}
          showBorder={showBorder}
          isIconAvailable={isIconAvailable}
          onLayout={onLayout}
          toggleDropdown={toggleDropdown}
          iconType={iconType as IconNewOptions}
          defaultLabel={type !== DropdownTypes.DEFAULT_WITH_IMAGE_DOWNLOAD_REPORT ? value || title : title}
          dropdownVisible={dropdownVisible}
          type={type}
          value={placeHolder}
          clearSelection={clearSelection}
          chevronColor={chevronColor}
          disabled={disabled}
          disabledBg={disabledBg}
          buttonWidth={buttonWidth}
          borderColor={borderColor}
          titleColor={titleColor}
          fontWeight={fontWeight}
          boxheight={boxheight}
        />
        {renderPortal(renderDropDown)}
        {touched && !!error && (
          <>
            <SpacerNew size={2} />
            <Text testID={'textInputErrorId'} color="ERROR" type="h4Bold">
              {error}
            </Text>
          </>
        )}
      </Box>
    )
  }
}

export { DropdownOptimised }
